export class EvidenceFile {
    fileId: string;
    evidenceType: string;

    fileName: string;
}

export class DisputeEvidenceSubmitRequestData {
    disputeId: string;
    additionalInformation: string;
    evidenceFiles: EvidenceFile[] = [];
}
